import { Entity, Fields, Relations, Allow } from "remult";
import { User } from "../user/entity";
import { Opportunity } from "../opportunity/entity";

@Entity("opportunity-interaction-log", {
    allowApiRead: false, // @@deny('all', true) in .zmodel
    allowApiCrud: false
})
export class OpportunityInteractionLog {
    @Fields.string()
    id = "";

    @Fields.string({ dbName: "user_id" })
    userId = "";

    @Relations.toOne(() => User, "userId")
    user?: User;

    @Fields.string({ dbName: "opportunity_id" })
    opportunityId = "";

    @Relations.toOne(() => Opportunity, "opportunityId")
    opportunity?: Opportunity;

    @Fields.string()
    action = ""; // OpportunityInteractionAction enum

    @Fields.integer({ dbName: "index_in_feed", allowNull: true })
    indexInFeed?: number;

    @Fields.number({ dbName: "raw_distance_km", allowNull: true })
    rawDistanceKm?: number;

    @Fields.number({ dbName: "raw_days_remaining", allowNull: true })
    rawDaysRemaining?: number;

    @Fields.string({ dbName: "raw_manager_urgency", allowNull: true })
    rawManagerUrgency?: string;

    @Fields.boolean({ dbName: "raw_is_pop_match", allowNull: true })
    rawIsPopMatch?: boolean;

    @Fields.boolean({ dbName: "raw_is_cat_match", allowNull: true })
    rawIsCatMatch?: boolean;

    @Fields.boolean({ dbName: "raw_is_remote", allowNull: true })
    rawIsRemote?: boolean;

    @Fields.integer()
    version = 1;

    @Fields.createdAt({ dbName: "created_at" })
    createdAt = new Date();

    @Fields.updatedAt({ dbName: "updated_at" })
    updatedAt = new Date();
}
